
import CustomFileCard from './../../../../components/CustomFileCard';
import CustomChip from '../../../../components/CustomChip';
import { colors } from '../../../../enums/colors';
import { FIELD_TYPE} from './../../Visitor/Type/Model/Model';
import { DownloadIcon } from '../../../../components/buttons/IconButtons';
import TextCard from './TextCard';
import { POSITION_MODEL } from '../../../../Helpers/PositionModel';
import {downloadActionFile} from "../../../../Apis/functions";

/**
 * FileCardList Component
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 * Renders a list of file cards with optional chips and download buttons.
 *
 * @param {Object} props - Component props
 * @param {Array} props.data - Array of file items to display
 */
const FileCardList = ({ item }) => {
    const subtitleChip = (
        <div className='mt-2'>
            <CustomChip
                background={colors.secondary100}
                fontColor={colors.secondary700}
                borderColor={colors.secondary150}
                  legend={item.levelTypeTrans}
                icon={item.icon}              
                className='icon-color-secondary-700'
                classNameIcon='icon-color-secondary-700'
                
            />
        </div>
    );
    return <div key={item.id} className='mb-3'>
        {item.levelType === FIELD_TYPE.TEXT.name && (
            <TextCard
                title={item.levelName}
                subtitle={subtitleChip}
                showChip={true}
                showText={true}
                text={item?.document}
                statusId={item?.statusId}
                copyOnClick={true}
            />
        )}
        {item.levelType === FIELD_TYPE.DOCUMENT.name && (
            <CustomFileCard
                downloadAtEnd={POSITION_MODEL.RIGHT}
                showIcon={false}
                downloadIcon={DownloadIcon}
                title={item.levelName}
                fileValue={item?.fileUploadDto?.filePath}
                subtitle={subtitleChip}
                showBtnDownload={true}
                showChip={true}
                buttonId={`btn_fcl_download_${item.id}`}
                onClick={() => downloadActionFile(item?.fileUploadDto?.filePath)}
                statusId={item?.statusId}
            />
        )}
    </div>
};

export default FileCardList;
